import WordSeparator from './Root.vue';
import CryptogramCreate from './views/CryptogramCreate.vue';
import CryptogramEdit from './views/CryptogramEdit.vue';
import CryptogramList from './views/CryptogramList.vue';

export default {
  path: 'gerador/criptogramas',
  name: 'admin-cryptogram-generator',
  component: WordSeparator,
  redirect: '/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-cryptogram-list',
      component: CryptogramList,
    },
    {
      path: 'novo/',
      name: 'admin-cryptogram-new',
      component: CryptogramCreate,
    },
    {
      path: ':puzzleId',
      name: 'admin-cryptogram-edit',
      component: CryptogramEdit,
    },
  ],
};
